
import { FaStarOfLife } from "react-icons/fa";

import './services.css';

const Services = () => {
   return(
      <div id="services">
           <div className='myexhead'>
    <h3 style={{marginBottom:5}} className=''>My Services</h3>
    <h2 style={{marginBottom:0}} className='fnt40'>Hire Me</h2>
       </div> 
<div className="myservcont">   
<div class="myserbox">
   <img width="40" height="40" className="" src="/uiuxdesign.png" alt="external-web-design-web-design-and-development-yogi-aprelliyanto-flat-yogi-aprelliyanto-2"/>
   <div className="mysb1">
      <h4 className="my3">Web Design / UIUX</h4>
      <p className="my3">Any of your idea's create from scratch to Web Design.</p>
   </div>
</div>
<div class="myserbox">
<img width="40" height="40" src="/web-development.png" alt="laptop-coding"/>   <div className="mysb1">
      <h4 className="my3">Web Development</h4>
      <p className="my3">Which are frontend and backend logics involves</p>
   </div>
</div>
<div class="myserbox">
<img width="40" height="40" src="/seo.png" alt="positive-dynamic"/>   <div className="mysb1">
      <h4 className="my3">SEO</h4>
      <p className="my3">Promote your business with organically to improve it.</p>
   </div>
</div>
</div>
<div className='role'>
    <div className='roleinfo'>
    <span>Web Design</span><span><FaStarOfLife/></span>
    <span>UIUX Development</span><span><FaStarOfLife/></span>
    <span>Hire Me</span><span><FaStarOfLife/></span>
    <span>Dynamic Website</span><span><FaStarOfLife/></span>
    <span>Mobile App Design</span><span><FaStarOfLife/></span>
    </div>
    </div>
</div>
   )
}
export default Services;

